import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { ItemContentComponent } from '../../item-content/item-content.component';

@Component({
    selector: 'app-check-bladder-size-item-v2',
    templateUrl: './check-bladder-size-item-v2.component.html',
    styleUrl: './check-bladder-size-item-v2.component.scss',
    imports: [ItemContentComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckBladderSizeItemComponentV2 implements SheetItemComponentBase {

	@Input() row!: Row;
    @Input() startLabel!: string;
    @Input() endLabel!: string;

	constructor() {
	}
}